(function ($, Drupal) {
  'use strict';

  /*
   * Uses the mini pager in Druapl's Views. Tell the mini pager how many items you
   * wish to return at a time.
   */

  Drupal.behaviors.theshireInfinity = {
    enabled: true,
    gaPageView: false, // send a page view on each infinite load

    // These will vary for each use (see activate() below)
    overallContainerClass: '',
    scrollContainerClass: '',
    appendTo: '',

    activate: function () {
      var that = this;

      // This may have been disabled for reasons
      if (this.enabled !== true) {
        return;
      }

      // Only possible when there's a pager
      if ($('.pager').length === 0) {
        return;
      }

      if ($('.view-display-id-archive_page').length) {
        this.overallContainerClass = '.view-display-id-archive_page';
        this.scrollContainerClass = '.view-display-id-archive_page > .view-content';
        this.appendTo = '.views-row';
      }

      // Only when it's specifically needed
      if (this.overallContainerClass === '') {
        return;
      }

      // Insert the loading feedback
      var loadStatus  = '<div class="page-load-status">';
          loadStatus += '  <div class="infinite-scroll-request">';
          loadStatus += '    <div class="sk-folding-cube">';
          loadStatus += '      <div class="sk-cube1 sk-cube"></div>';
          loadStatus += '      <div class="sk-cube2 sk-cube"></div>';
          loadStatus += '      <div class="sk-cube4 sk-cube"></div>';
          loadStatus += '      <div class="sk-cube3 sk-cube"></div>';
          loadStatus += '    </div>';
          loadStatus += '  </div>';
          loadStatus += '  <div class="infinite-scroll-last">The end</div>';
          loadStatus += '  <div class="infinite-scroll-error">Cannot load content</div>';
          loadStatus += '</div>';
      $(this.overallContainerClass).append(loadStatus);

      // Get the masonry grid
      var msnry = Drupal.behaviors.theshire.masonryGrid.data('masonry');
      console.log(msnry);

      // Init the infiniteScroll tool
      $(this.scrollContainerClass).infiniteScroll({
        path: function () {
          // Note: 'this' is the infiniteScroll instance in here
          var nextPage = this.loadCount + 1;
          return window.location.pathname + '?page=' + nextPage + '&inject=true';
        },
        checkLastPage: '.pager__item--next a',
        append: this.appendTo,
        outlayer: msnry,
        history: false, // We'll do our own history management
        hideNav: '.pager',
        status: '.page-load-status',
        debug: false
      });

      // Things to do after the content has been inserted
      // Ref. https://developers.google.com/analytics/devguides/collection/analyticsjs/pages
      $(this.scrollContainerClass).on('append.infiniteScroll', function (event, response, path, items) {
        if (that.gaPageView === true && typeof(window.ga) === "function") {
          ga('set', 'page', path);
          ga('send', 'pageview');
        }
      });

    }
  };

})(jQuery, Drupal);
